import axios from "axios";
import { useEffect, useState } from "react";
import { API_BASE_PATH } from "../../environment";

const DEPARTMENT_BASE_URL = `${API_BASE_PATH}/Admindashboard/departments-with-employee-name`;

// useDepartmentEmployeeData.ts
export type Department = {
  department_name: string;
  employee_usernames: string[];
};

export type JobType = {
  job_type_name: string;
  employee_count: number;
};

export type DepartmentResponse = {
  departments: Department[];
  job_types: JobType[];
  total_employee_count: { total_employee_count: number }[];
};

const useDepartmentEmployeeData = () => {
  const [data, setData] = useState<DepartmentResponse | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetch = async () => {
      setLoading(true);
      try {
        const res = await axios.get(DEPARTMENT_BASE_URL);
        setData(res.data);
      } catch (e) {
        console.error("Error fetching department employee data", e);
      } finally {
        setLoading(false);
      }
    };

    fetch();
  }, []);

  return { data, loading };
};

export default useDepartmentEmployeeData;
